import { environment } from '../../../environments/environment';
import { TokenDto } from '../services/auth/models/token.dto';

export function isFakeBackendEnabled(): boolean {
  return environment.useFakeBackend === true;
}

export function createFakeJwt(expiresInMs = 1000 * 60 * 60 * 8): string {
  const header = { alg: 'HS256', typ: 'JWT' };
  const payload = {
    sub: 'user-uuid',
    email: 'unico-tenant@unico.com',
    exp: Math.floor((Date.now() + expiresInMs) / 1000),
  };

  return `${encodeBase64Url(header)}.${encodeBase64Url(payload)}.fake-signature`;
}

export function createFakeTokenDto(
  accessExpiresInMs = 1000 * 60 * 60 * 8,
  refreshExpiresInMs = 1000 * 60 * 60 * 24 * 7,
): TokenDto {
  const token = createFakeJwt(accessExpiresInMs);
  const refreshToken = createFakeJwt(refreshExpiresInMs);
  const expiresAt = new Date(Date.now() + accessExpiresInMs).toISOString();
  const refreshExpiresAt = new Date(Date.now() + refreshExpiresInMs).toISOString();

  return {
    token,
    refreshToken,
    expiresAt,
    refreshExpiresAt,
  };
}

export function delay(ms = 150): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

function encodeBase64Url(value: object): string {
  const json = JSON.stringify(value);
  const base64 = btoa(json);

  return base64.replaceAll('+', '-').replaceAll('/', '_').replaceAll('=', '');
}
